import { useEffect, useState } from 'react'
import {
  useCustomersStore,
  useSaleTransformer,
  useUsersStore,
} from '../../../../ng-compat/hooks'
import { useAppSelector } from '../../../../state/hooks'
import { selectActiveOutletId } from '../../../../state/slices/posState/posStateSlice'
import { hydrateSales } from './hydrateSales'
import { getParkedSales } from './getParkedSales'
import { generateSaleSummaries, SaleSummary } from './generateSaleSummaries'

export const useParkedSales = (active: boolean) => {
  const customersStore = useCustomersStore()
  const usersStore = useUsersStore()
  const saleTransformer = useSaleTransformer()
  const [salesResult, setSalesResult] = useState<{
    hasMore: boolean
    sales: SaleSummary[]
  } | null>(null)
  const outletId = useAppSelector(selectActiveOutletId)

  useEffect(() => {
    if (active && outletId && !salesResult) {
      getParkedSales(outletId).then(result => {
        return hydrateSales(result.sales, {
          usersStore,
          customersStore,
          saleTransformer,
        }).then(hydratedSales => {
          setSalesResult({
            ...result,
            sales: generateSaleSummaries(hydratedSales),
          })
        })
      })
    } else if (!active && salesResult) {
      setSalesResult(null)
    }
  }, [
    active,
    customersStore,
    outletId,
    saleTransformer,
    salesResult,
    usersStore,
  ])

  return salesResult
}
